import moment from 'moment';

const mutationTypes = {
    UPDATE_AGE: 'UPDATE_AGE',
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET',
};

// Initial State
const state = {
    dateOfBirth: null,
    durationOfSymptoms: null,
    ageOfPerson: null,
};

// Getters
const getters = {
    value: state => key => state[key],
};

// Actions
const actions = {

    update({ commit, dispatch }, { key, value }) {
        commit(mutationTypes.UPDATE_VALUE, { key, value });
    },
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_AGE](state, age) {
        state.ageOfPerson = age.age;
    },
    [mutationTypes.UPDATE_VALUE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.RESET](state) {
        state.ageOfPerson = null;
        state.dateOfBirth = null;
        state.durationOfSymptoms = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/meso.js